import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type HydraUpdatePersonalDetailsResponse = {
  id: {
    unicity: number
  }
  homePhone: string
  email: string
  mustVerifyEmail: boolean
  href: string
  error?: {
    code: number
    message: string
    error_message: string
  }
}

type Props = {
  email: string
  phoneNumber: string
  hydraToken: string
  currentEmail: string
  currentPhoneNumber: string
}

export const HydraUpdatePersonalDetails = ({
  email,
  phoneNumber,
  hydraToken,
  currentEmail,
  currentPhoneNumber,
}: Props) => {
  const request: SendRequestType = {
    method: 'POST',
    data: {
      email: email || currentEmail || '',
      homePhone: phoneNumber || currentPhoneNumber || '',
    },
    url: '/customers/me',
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraUpdatePersonalDetailsResponse>(request)
}
